<template>
    <div>
        <el-dialog title="发送通知" :visible.sync="showAdd" width="650px" :close-on-click-modal="false" center>
            <el-form :inline="true">
                <el-row>
                    <el-form-item label="发布时间">
                        <el-radio-group v-model="addFrom.isTimeOut">
                            <el-radio :label="2">立即发布</el-radio>
                            <el-radio :label="1">定时发布</el-radio>
                        </el-radio-group>
                        <el-date-picker v-if="addFrom.isTimeOut == '1'" v-model="addFrom.sendTime" type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择时间">
                        </el-date-picker>
                    </el-form-item>
                </el-row>

                <el-row>
                    <el-form-item label="消息类型">
                        <el-select v-model="addFrom.type" clearable placeholder="请选择" clear filterable>
                            <el-option v-for="(item, index) in typeList" :key="index"
                            :label="'(' + item.type + ')' + item.title+','+item.noticeType" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="消息标题">
                        <el-input style="width:400px;" max-length="50" clearable v-model="addFrom.title"></el-input>
                    </el-form-item>
                </el-row>

                <el-row>
                    <el-form-item label="消息内容">
                        <el-input type="textarea" :rows="4" maxlength="400" style="width:400px;" placeholder="请输入内容"
                            v-model="addFrom.content">
                        </el-input>
                    </el-form-item>
                </el-row>

                <el-row>
                    <el-form-item label="城市">
                        <el-select v-model="listQuery.cityId" clearable placeholder="请选择城市" filterable>
                            <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityName"
                                :value="item.id + ''"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="驿站">
                        <el-select v-model="listQuery.postStationId" clearable placeholder="请选择驿站" filterable>
                            <template v-for="(item, index) in postStationList">
                                <el-option :key="index" v-if="item.cityId == listQuery.cityId"
                                    :label="item.postStationName" :value="item.id + ''"> </el-option>
                            </template>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="服务站">
                        <el-select v-model="listQuery.stationId" clearable placeholder="请选择服务站" filterable>
                            <template v-for="(item, index) in allStationList">
                                <el-option :key="index" v-if="item.postStationId == listQuery.postStationId"
                                    :label="item.stationName" :value="item.id + ''"> </el-option>
                            </template>
                        </el-select>
                    </el-form-item>
 
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">加载人数</el-button>
                   

                    <label style="color:red;cursor:pointer; "  @click="zankai=(!zankai)">
                        <a v-if="zankai == false">更多条件</a>
                        <a v-if="zankai">折叠</a>
                    </label>
                    <div v-if="zankai">
                        <el-form-item label="服务者编号">
                            <el-input v-model="listQuery.workerNo" maxlength="11" style="width:150px"
                                placeholder="请输入服务者编号" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="服务者姓名">
                            <el-input v-model="listQuery.workerName" maxlength="11" style="width:150px"
                                placeholder="请输入服务者姓名" clearable></el-input>
                        </el-form-item>

                        <el-form-item label="服务者电话">
                            <el-input v-model="listQuery.workerTel" maxlength="11" style="width:150px"
                                placeholder="请输入服务者电话" clearable></el-input>
                        </el-form-item>

                        <el-form-item label="服务者标签">
                            <el-select v-model="listQuery.label" clearable placeholder="请选择" filterable>
                                <el-option v-for="(item, index) in labelList" :key="index" :label="item.labelName"
                                    :value="item.id + ''"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>

                    <br />
                    <label>发送人数:{{total}}</label>
                    <el-table :data="listData" border style="width: 100%" max-height="300" class="table">
                        <el-table-column prop="workerNo" label="服务者编号"></el-table-column>
                        <el-table-column prop="workerName" label="服务者名称"></el-table-column>
                    </el-table>
                </el-row>


            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showAdd = false">关闭</el-button>
                <el-button type="primary" @click="save">发送</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import service from '@/script/api/service';
import wmsApi from "@/script/api/wmsApi";
import workercrmapi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data";
import label from '../workercrm/label/label.vue';

export default {
    components: { label },
    data() {
        return {
            zankai: false,
            cityList: [],
            postStationList: [],
            allStationList: [],
            labelList: [],
            listQuery: {
                selectType: 1,//我的服务者
                fieldType: 1,//指定字段
                state:2,//在职状态
                cityId: null,
                postStationId: null,
                stationId: null,
                workerNo: null,
                workerName: null,
                label: null,
                userId: globalData.userInfo.id,
            },
            showAdd: false,
            typeList: [],
            listData: [],
            total:0,
            addFrom: {
                isTimeOut: 2,
                sendTime:'',
                type: '',
                title: '',
                content: '',
                workerList: [],
                sendName: '',
                sendUserId: '',
            },

        };
    },
    methods: {
       
        showAddView() {
            this.showAdd = true;
            this.getTypeData();
            this.getAllSkill();
            this.getAllCity();
            this.getAllPostStation();
            this.getAllStationList();
 
            this.listData=[];
            this.listQuery= {
                selectType: 1,//我的服务者
                fieldType: 1,//指定字段
                state:2,//在职状态
                cityId: null,
                postStationId: null,
                stationId: null,
                workerNo: null,
                workerName: null,
                label: null,
                userId: globalData.userInfo.id,
            };
            this.addFrom = {
                isTimeOut: 2,
                type: '',
                title: '',
                content: '',
                workerList: [],
                sendName: globalData.userInfo.userName,
                sendUserId: globalData.userInfo.id
            }
        },
        save() {
            if(this.checkForm()==false){
                return ;
            }

            let arr=[];
            this.addFrom.workerList.forEach(e=>{
                arr.push({workerName:e.workerName,workerNo:e.workerNo,stationId:e.stationId});
            })
            this.addFrom.workerList=arr;

            service.$axioWorkerNoticeSendNotice(this.addFrom).then((res) => {
                if (res.data.errno == 0) {
                    this.$message.success('发送成功');
                    this.showAdd = false;
                    this.$emit('querySearch');
                }else{
                    this.$message.success('发送失败');
                }
            })

        },
        checkForm(){
            if(this.addFrom.isTimeOut==1&&(this.addFrom.sendTime==null||this.addFrom.sendTime=='')){
                this.$message.error('请选择定时发送时间');
                return false;
            }
            if(this.addFrom.type==null||this.addFrom.type==''){
                this.$message.error('请选消息类型');
                return false;
            }
            if(this.addFrom.title==null||this.addFrom.title==''){
                this.$message.error('请输入消息标题');
                return false;
            }
            if(this.addFrom.content==null||this.addFrom.content==''){
                this.$message.error('请输入消息内容');
                return false;
            }
            if(this.addFrom.workerList.length==0){
                this.$message.error('请点击加载发送人数');
                return false;
            }
        },
        getTypeData() {
            service.$axioWorkerNoticeGetTypelist().then((res) => {
                if (res.data.errno == 0) {
                    this.typeList = res.data.data;
                }
            })
        },
        querySearch(){
            this.listQuery.pageSize = 99999;
            this.listQuery.pageNum = 1;
            workercrmapi.$axiosGetWorkerList(this.listQuery).then((res) => {
                if (res.data.errno == 0) {
                    this.listData = res.data.data.list; 
                    this.addFrom.workerList=res.data.data.list;
                    this.total = res.data.data.total; 
                }
            });
        },
        getAllSkill() {
            workercrmapi.$axiosEmLableSkillGetAllLabelSkill().then((res) => {
                if (res.data.errno == 0) {
                    this.labelList = res.data.data;
                }
            });
        },
        getAllCity() {
            //城市下拉框
            wmsApi
                .$axiosgetallCity({ userId: globalData.userInfo.id })
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.cityList = res.data.data;
                    }
                });
        },
        getAllPostStation() {
            //驿站
            workercrmapi
                .$axiosPostStationgetAllList({ userId: globalData.userInfo.id })
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.postStationList = res.data.data;
                    }
                });
        },
        getAllStationList() {
            //服务站
            wmsApi
                .$axiosGetAllStationList({ userId: globalData.userInfo.id })
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.allStationList = res.data.data;
                    }
                });
        },

    }
};
</script>
<style lang="">
  </style>
  